import React from 'react';
import './AboutSection.css';
const AboutSection = () => {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <section className="about-section">
      <div className="about-text animate-fadeUp">
        <p>
          Welcome to <span className="highlight">Krisara Gastro</span>, where expert digestive health meets 
          compassionate care. <span className="highlight-bold">Led by Dr. Shruti Sagar</span>, renowned 
          <span className="highlight"> gastroenterologist</span>, our team specialises in advanced diagnostics and 
          personalised treatments for conditions ranging from <span className="highlight">acid reflux</span> and 
          <span className="highlight"> irritable bowel syndrome</span> to liver disorders.
        </p>
        <p className="delay-2">
          Combining cutting-edge technology with a patient-first approach, we’re dedicated to restoring your 
          <span className="highlight"> comfort</span> and <span className="highlight">confidence</span> one gentle, 
          efficient procedure at a time.
        </p>
      </div>
    </section>
  );
};
export default AboutSection;